import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { lighten, makeStyles } from '@material-ui/core/styles'
import { createTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import DeleteIcon from '@material-ui/icons/Delete'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import { loginFormsRedirect } from './utils'
import { getBaseURL } from '../GlobalComponents/URLs'

const URLS = {
    perfReview: getBaseURL() + 'webapi/form/performanceReviews',
    downloadPerfReviews: getBaseURL() + 'webapi/form/downloadPerformanceReviews',
    recordTemplate: getBaseURL() + 'formgeneric/record/',
}

let today = new Date()
let tomorrow = new Date(today)
tomorrow.setDate(tomorrow.getDate() + 1)
let STUB_PROPS = [
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
    {
        supervisor: 'Julius Beard',
        employee: 'Garon Leblanc',
        hireDate: today,
        lastReviewDate: new Date(),
        location: 'NSSC',
    },
    {
        supervisor: 'Mark Prutz',
        employee: 'Morgan McGinn',
        hireDate: tomorrow,
        lastReviewDate: new Date(),
        location: 'aaaa',
    },
]

let theme = createTheme({
    typography: {
        fontFamily:
            'wf_segoe-ui_light,\'Segoe UI Light\',\'Segoe WP Light\',\'Segoe UI\',\'Segoe WP\',Tahoma,Arial,sans-serif',
    },
})
theme = responsiveFontSizes(theme)

function createData(supervisor, employee, hireDate, lastReviewDate, location) {
    return { supervisor, employee, hireDate, lastReviewDate, location }
}

//const rows = STUB_PROPS

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) return order
        return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
}

const headCells = [
    { id: 'Supervisor', numeric: false, disablePadding: false, label: 'Supervisor' },
    { id: 'Employee', numeric: false, disablePadding: false, label: 'Employee' },
    { id: 'Location', numeric: false, disablePadding: false, label: 'Location' },
    { id: 'HireDate', numeric: false, disablePadding: false, label: 'Hire Date' },
    { id: 'LastReviewDate', numeric: false, disablePadding: false, label: 'Last Review' },
    { id: 'Completed', numeric: false, disablePadding: false, label: 'Completed' },
]

function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <ThemeProvider theme={theme}>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.numeric ? 'left' : 'right'}
                            padding={headCell.disablePadding ? 'none' : 'default'}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc'
                                            ? 'sorted descending'
                                            : 'sorted ascending'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </ThemeProvider>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
}

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
    },
}))

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles()
    const { numSelected } = props

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <ThemeProvider theme={theme}>
                {numSelected > 0 ? (
                    <Typography
                        className={classes.title}
                        color="inherit"
                        variant="subtitle1"
                        component="div"
                    >
                        {numSelected} selected
                    </Typography>
                ) : (
                    <Typography className={classes.title} id="tableTitle" component="div">
                        <Box fontWeight="fontWeightLight" fontSize={45}>
                            Performance Reviews
                        </Box>
                    </Typography>
                )}
            </ThemeProvider>
            {numSelected > 0 ? (
                <Tooltip title="Delete">
                    <IconButton aria-label="delete">
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            ) : (
                <Tooltip title="Download Records">
                    <IconButton aria-label="filter list">
                        <DownloadIcon url={URLS.downloadPerfReviews} />
                    </IconButton>
                </Tooltip>
            )}
        </Toolbar>
    )
}

// going to need to send back download complete cookie and poll for it
const DownloadIcon = (props) => {
    const [inProgress, setInProgress] = React.useState(false)
    return inProgress ? (
        <CircularProgress size={20} />
    ) : (
        <ArrowDownwardIcon
            onClick={() => {
                window.location.href = props.url
                // setInProgress(true)
            }}
        />
    )
}
EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}))

export default function EnhancedTable() {
    const classes = useStyles()
    const [order, setOrder] = React.useState('asc')
    const [orderBy, setOrderBy] = React.useState('calories')
    const [selected, setSelected] = React.useState([])
    const [page, setPage] = React.useState(0)
    const [dense, setDense] = React.useState(false)
    const [rowsPerPage, setRowsPerPage] = React.useState(5)
    const [data, setData] = React.useState(false)
    const [viewRows, setViewRows] = React.useState([])
    const [rows, setRows] = React.useState([])
    //   const [headCells, setHeadCells] = React.useState([])
    React.useEffect(() => {
        document.title = 'Performance Reviews'
        fetch(URLS.perfReview, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    // no cookies
                    let redirectPath = '/FormGeneric/review'
                    loginFormsRedirect(redirectPath)
                }
            })
            .then((json) => {
                // the dt isnt typed so it sends string booleans
                setRows(json.map((row) => ({ ...row, Completed: row.Completed === 'True' })))
            })
    }, [])
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n.name)
            setSelected(newSelecteds)
            return
        }
        setSelected([])
    }

    const handleClick = (event, recordId) => {
        let recordUrl = URLS.recordTemplate + recordId
        window.open(recordUrl)
        // window.open("https://nettest.awc-inc.com/webapi/form/downloadperformancereviews")
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const handleChangeDense = (event) => {
        setDense(event.target.checked)
    }

    const isSelected = (name) => selected.indexOf(name) !== -1

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage)
    const [filter, setFilter] = React.useState('')
    const [onlyRecent, setOnlyRecent] = React.useState(true)

    React.useEffect(() => {
        let mostRecentReview = {}
        rows.forEach((row) => {
            let record = parseInt(row.RecordId)
            let user = row.Employee
            mostRecentReview[user] = Math.max(mostRecentReview[user] || 0, record)
        })

        let newViewRows = rows.filter((row) =>
            filter === '' ? true : row.Employee.toLowerCase().includes(filter.toLowerCase())
        )
        if (onlyRecent)
            newViewRows = newViewRows.filter(
                (row) => mostRecentReview[row.Employee] === parseInt(row.RecordId)
            )

        setViewRows(newViewRows)
    }, [filter, onlyRecent, rows])
    const getRowContent = (row, col) => {
        if (row[col.id] === true || row[col.id] === false)
            return row[col.id] ? 'Yes' : `No (Sent ${new Date(row.CreatedDate).toDateString()})`
        if (!isNaN(new Date(row[col.id]))) return new Date(row[col.id]).toLocaleDateString()
        return row[col.id]
    }
    return (
        <div className={classes.root}>
            {/* <a href='https://nettest.awc-inc.com/webapi/form/downloadperformancereviews'> aaaaa </a> */}
            <Paper className={classes.paper}>
                <EnhancedTableToolbar numSelected={selected.length} />
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ marginLeft: 30, marginRight: 50 }}>
                        Filter By Name{' '}
                        <TextField
                            value={filter}
                            onChange={(e) => {
                                setFilter(e.target.value)
                            }}
                        />
                    </div>
                    <div>
                        Only show most recent
                        <Checkbox
                            checked={onlyRecent}
                            onChange={(e) => setOnlyRecent(e.target.checked)}
                        />
                    </div>
                </div>
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            //   numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            //   onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={viewRows.length}
                        />
                        <TableBody>
                            {stableSort(viewRows, getComparator(order, orderBy))
                                // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row.name)
                                    const labelId = `enhanced-table-checkbox-${index}`

                                    return (
                                        <TableRow
                                            hover
                                            onClick={(event) => handleClick(event, row.RecordId)}
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={viewRows.name}
                                            selected={isItemSelected}
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: row.Completed
                                                    ? ''
                                                    : 'rgba(250,250,0,0.5)',
                                            }}
                                        >
                                            {headCells.map((col) => (
                                                <TableCell align="right">
                                                    {getRowContent(row, col)}
                                                </TableCell>
                                            ))}
                                            {/* <TableCell component="th" id={labelId} scope="row">
                        {row.supervisor}
                      </TableCell>
                      <TableCell align="right">{row.employee}</TableCell>
                      <TableCell align="right">{row.location}</TableCell>
                      <TableCell align="right">{row.hireDate.toLocaleDateString()}</TableCell>
                      <TableCell align="right">{row.lastReviewDate.toLocaleDateString()}</TableCell> */}
                                        </TableRow>
                                    )
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        /> */}
            </Paper>
            {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
        </div>
    )
}
